export const CategoryFormItem = {
  CATEGORY_NAME: 'name',
  MULTI_PRODUCT: 'multiProduct',
};
